import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CcfAppEnlighten,
  CcfAppSchedule,
  CcfContactHistory,
  CcfCopilot,
  CcfCustomerCard,
  CcfDirectory,
  CcfQueueCounter,
  CcfQuickReplies,
  getIsLiveCopilotEnabled,
  getPanelAppNavigationItems,
  getQuickAppNavigationItems,
  getReArrangeMenuState,
  globalActions,
} from '@nice-ccf/ui-components';
import {
  CcfTabs,
  CcfHeader,
  CcfCalendarIcon,
  CcfCustomerCardIcon,
  CcfDirectoryIcon,
  CcfSentimentIcon,
  CcfEnlightenIcon,
  CcfFlashIcon,
  CcfCopilotSuggestionIcon,
  CcfWorkHistoryIcon,
  CcfQueueIcon,
  CcfCopilotIcon,
  CcfIlluminateStarIcon,
  CcfBox,
} from '@nice-ccf/ui-controls';
import CircularJSON from 'circular-json';
import styles from './ccf-app-space.module.scss';
import {
  activeContactSelector,
  selectAppSpaceActiveIndex,
  updateAppSpaceTabIndex,
  setNewCommitment,
  selectAppSpaceActiveTab,
  updateAppSpaceTab,
} from '../ccf-inbox/ccf-inbox.slice';
import { Direction } from '@mui/material';
import { useTranslator } from '@nice-ccf/ui-controls';
import { getApplicationDirection } from '@nice-ccf/ui-components';
import { AppSpace } from '../../enums/app-space-tabs';
import { AppSpaceTab } from './model/app-space-tab';
import CCfRtig from '../ccf-rtig/ccf-rtig';
import {
  DigitalChannelStatus,
  DigitalChannelType,
  MediaType,
  StorageKeys,
  VoiceContactStatus,
} from '@nice-ccf/core-sdk';
import CcfAppSpacePopover from './ccf-app-space-popover/ccf-app-space-popover';
import CcfLiveCopilot from './ccf-copilot/ccf-live-copilot';
import CcfConsumerCard from './ccf-consumer-card/ccf-consumer-card';

/* eslint-disable-next-line */
export interface CcfAppSpaceProps {}


/**
 * Renders the CcfAppSpace component.
 * @param props - The optional props for the CcfAppSpace component.
 * @returns The JSX element representing the CcfAppSpace component.
 *  @example - `<CcfAppSpace />`
 */
export function CcfAppSpace(props?: CcfAppSpaceProps) {
  const [translate] = useTranslator();
  const appSpaceTabs: AppSpaceTab[] = [
    // {
    //   icon: <CcfCustomerCardIcon className={styles.tabsIcon} />,
    //   element: <CcfCustomerCard />,
    //   tooltip: 'ContactCard',
    //   isActive: false,
    //   menuName: AppSpace.CUSTOMERCARD,
    // },
    {
      icon: <CcfCustomerCardIcon className={styles.tabsIcon} />,
      element: (
        <CcfConsumerCard/>
      ),
      tooltip: translate('contactCard'),
      isActive: true,
      menuName: AppSpace.CUSTOMERCARD,
    },
    // {
    //   icon: <CcfCustomerCardIcon className={styles.tabsIcon} />,
    //   element: <CcfCustomerCard />,
    //   tooltip: 'ContactCard',
    //   isActive: true,
    //   menuName: AppSpace.CUSTOMERCARD,
    // },
    {
      icon: (
        <CcfIlluminateStarIcon
          className={styles.tabsIcon}
          viewBox="4 3 28 28"
        />
      ),
      element: <CcfCopilot />,
      tooltip: `${translate('enlighten')} Copilot`,
      isActive: false,
      menuName: AppSpace.COPILOT,
    },
    {
      icon: <CcfCalendarIcon className={styles.tabsIcon} />,
      element: <CcfAppSchedule isfullView={false} />,
      tooltip: translate('schedule'),
      isActive: true,
      menuName: AppSpace.SCHEDULE,
    },

    {
      icon: <CcfDirectoryIcon className={styles.tabsIcon} />,
      element: <CcfDirectory isFullView={false} />,
      tooltip: translate('directory'),
      isActive: true,
      menuName: AppSpace.DIRECTORY,
    },

    {
      icon: <CcfQueueIcon className={styles.tabsIcon} />,
      element: <CcfQueueCounter />,
      tooltip: translate('queueCounter'),
      isActive: true,
      menuName: AppSpace.QUEUE,
    },
    {
      icon: <CcfWorkHistoryIcon className={styles.tabicon} />,
      element: <CcfContactHistory isAppSpace={true} />,
      tooltip: translate('contactHistory'),
      isActive: true,
      menuName: AppSpace.CONTACT_HISTORY,
    },
    {
      icon: <CcfSentimentIcon className={styles.tabicon} />,
      element: <CCfRtig resourceBaseUrl={'.'} />,
      tooltip: translate('sentiment'),
      isActive: false,
      menuName: AppSpace.SENTIMENT,
    },
    {
      icon: <CcfFlashIcon className={styles.tabsIcon} />,
      element: <CcfQuickReplies />,
      tooltip: translate('quickReply'),
      isActive: false,
      menuName: AppSpace.QUICK_REPLY,
    },
  ];
  const [appSpaceMenus, setAppSpaceMenus] = useState([] as AppSpaceTab[]);
  const activeContact = useSelector(activeContactSelector);
  const currentTab = useSelector(selectAppSpaceActiveIndex);
  const activeTab = useSelector(selectAppSpaceActiveTab);
  //const showEnlightenTab = useSelector(getEnlightenTabFeatureToggle);
  const quickAppNavigationItemsLS = useSelector(getQuickAppNavigationItems);
  const panelAppNavigationItems = useSelector(getPanelAppNavigationItems);
  const dispatch = useDispatch();
  const appDirection: Direction = useSelector(getApplicationDirection);
  const isNeedtoReArrangeMenu = useSelector(getReArrangeMenuState);
  const appSpaceCardRef = useRef<HTMLDivElement | null>(null);
  const [isAppSpaceHeaderVisible, setIsAppSpaceHeaderVisible] = useState(true);

  /**
   * Used to update the app space tab menuName and tab index
   * @param newTabIndex - number
   * @example - handleChange(0)
   */
  const handleChange = (newTabIndex: number) => {
    dispatch(setNewCommitment(false));
    dispatch(updateAppSpaceTabIndex({ index: newTabIndex }));
    dispatch(updateAppSpaceTab({ tab: appSpaceMenus[newTabIndex]?.menuName }));
  };
  useEffect(() => {
    if (activeTab) {
      let activeTabIndex = 0;
      //const activeTabs = appSpaceMenus.filter((tab) => tab.isActive);
      if (appSpaceMenus.find((tab) => tab.menuName === activeTab)) {
        activeTabIndex = appSpaceMenus.findIndex(
          (tab) => tab.menuName === activeTab
        );
      }

      dispatch(updateAppSpaceTabIndex({ index: activeTabIndex }));
    }
  }, [appSpaceMenus,activeTab]);

  useEffect(() => {
    if(activeContact?.copilotAssist === 'Yes') {
      dispatch(updateAppSpaceTabIndex({ index: 1 }));
      dispatch(updateAppSpaceTab({ tab: AppSpace.COPILOT }));
    }
  },[]);

  useEffect(() => {
    if (activeContact !== null && activeContact !== undefined) {
      let updatedMenus = [...appSpaceTabs]; // Create a shallow copy to avoid direct mutation

      // Determine if certain conditions are met to update the isActive status
      const isCopilotActive =
        activeContact !== null &&
        activeContact !== undefined &&
        (activeContact.media === MediaType.VIDEOCALL ||
          activeContact.media === MediaType.VOICE ||
          activeContact.channel === DigitalChannelType.CHAT ||
          activeContact.channel === DigitalChannelType.EMAIL) &&
        activeContact.copilotAssist === 'Yes';
      const isQuickReplyActive = activeContact?.media !== MediaType.VOICE;
      const isSentimentActive = activeContact?.media === MediaType.VOICE;
      const isConsumerCardActive =
        activeContact !== null && activeContact !== undefined; // Assuming based on the original logic

      // Update isActive status based on the conditions above
      updatedMenus = updatedMenus.map((menu) => {
        if (menu.menuName === AppSpace.COPILOT) {
          return { ...menu, isActive: isCopilotActive };
        } else if (menu.menuName === AppSpace.QUICK_REPLY) {
          return { ...menu, isActive: isQuickReplyActive };
        } else if (menu.menuName === AppSpace.SENTIMENT) {
          return { ...menu, isActive: isSentimentActive };
        } else if (menu.menuName === AppSpace.CUSTOMERCARD) {
          return { ...menu, isActive: isConsumerCardActive };
        }
        return menu; // Return the menu as is if none of the conditions match
      });
      updatedMenus = updatedMenus.filter((tab) => tab.isActive);
      // if (activeContact?.copilotAssist === 'Yes') {
      //   dispatch(updateAppSpaceTabIndex({ index: 1 }));
      //   dispatch(updateAppSpaceTab({ tab: AppSpace.COPILOT }));
      // } else {
      //   dispatch(updateAppSpaceTabIndex({ index: 0 }));
      //   dispatch(updateAppSpaceTab({ tab: AppSpace.CUSTOMERCARD }));
      // }
      // Optionally, add new tabs if they meet certain conditions and are not already present
      // This part depends on the specific logic you need, similar to the checks above
      const panelAppNavigationItemsLS = updatedMenus.map((item: any) => {
        return {
          menuName: item.menuName,
          tooltip: item.tooltip,
        };
      });
      const CXoneNavigationItems = {
        quickApps: quickAppNavigationItemsLS,
        panelApps: panelAppNavigationItemsLS,
      };
      localStorage.setItem(
        StorageKeys.CXONE_NAVIGATION_ITEMS,
        CircularJSON.stringify(CXoneNavigationItems)
      );
      dispatch(
        globalActions.initializeCXoneNavigationItems(CXoneNavigationItems)
      );

      setAppSpaceMenus(updatedMenus); // Return the updated menus to update the state
    }
  }, [activeContact]); // Depend on activeContact to trigger updates

  /**
   * Used as a feature toggle between sentiment tab and enlighten tab
   * @param newTabIndex - number
   * @example - handleEnlightenTab(0)
   */
  const initialPopOverMenuContent = () => {
    return (
      <CcfAppSpacePopover showMenuList={true} appSpaceMenus={appSpaceMenus} />
    );
  };

  useEffect(() => {
    /**
     * Used as a feature toggle between sentiment tab and enlighten tab
     * @param newTabIndex - number
     * @example - handleEnlightenTab(0)
     */
    const updateLocalStorage = (tabs: any) => {
      const CXoneNavigationItems = {
        quickApps: quickAppNavigationItemsLS, // Assuming this is defined elsewhere
        panelApps: tabs.map((item: any) => ({
          menuName: item.menuName,
          tooltip: item.tooltip,
        })),
      };
      localStorage.setItem(
        StorageKeys.CXONE_NAVIGATION_ITEMS,
        CircularJSON.stringify(CXoneNavigationItems)
      );
      dispatch(
        globalActions.initializeCXoneNavigationItems(CXoneNavigationItems)
      ); // Assuming dispatch is defined elsewhere
    };

    if (isNeedtoReArrangeMenu) {
      const checkNavigationItemsLS = JSON.parse(
        localStorage.getItem(StorageKeys.CXONE_NAVIGATION_ITEMS) || '{}'
      );
      const isLocalStorageEmpty =
        Object.keys(checkNavigationItemsLS).length === 0;

      if (!isLocalStorageEmpty) {
        const appAppsOrder = checkNavigationItemsLS.panelApps.map(
          (item: any) => item.menuName
        );
        const sortedTabs = [...appSpaceMenus].sort((itemOne, itemTwo) => {
          return (
            appAppsOrder.indexOf(itemOne.menuName) -
            appAppsOrder.indexOf(itemTwo.menuName)
          );
        });
        setAppSpaceMenus(sortedTabs);
      } else {
        updateLocalStorage(appSpaceMenus);
        //setAppSpaceMenus(appSpaceMenus);
      }
      dispatch(globalActions.setReArrangeMenu(false));
    }
  }, [isNeedtoReArrangeMenu]);


  useEffect(() => {
    if (
      appSpaceCardRef?.current &&
      appSpaceCardRef?.current?.offsetWidth < 400
    ) {
      setIsAppSpaceHeaderVisible(false);
    } else {
      setIsAppSpaceHeaderVisible(true);
    }
  }, [appSpaceCardRef?.current?.offsetWidth]);

  /**
   * Renders the tab panels for the CcfAppSpace component.
   * @example renderTabPanels
   * @returns An array of CcfTabs.TabPanel components.
   */
  const renderTabPanels = () => {
    return appSpaceMenus.map((tab, index) => (
      <CcfTabs.TabPanel
        key={index} // Added a key for list rendering
        classes={{
          root: styles.tab,
          selected: styles.tabSelected,
        }}
        icon={tab.icon}
        tooltip={tab.tooltip}
      />
    ));
  };

  /**
   * Renders the content for the current tab.
   * @returns The JSX element representing the tab content.
   * @example renderTabContent
   */
  const renderTabContent = () => {
    const currentMenu = appSpaceMenus[currentTab];
    const contentClass = currentMenu?.menuName === 'My Schedule' ? styles.tabContentSectionForSKills : styles.tabContentSection;

    return (
      <section key={currentTab} className={contentClass}>
        {currentMenu?.element}
      </section>
    );
  };


  return (
    <section ref={appSpaceCardRef} className={styles.appSpaceCard}>
      <section className={styles.appSpaceHeader}>
        <CcfBox>
          <CcfHeader
            headerText={appSpaceMenus[currentTab]?.tooltip || ""}
            RightIcon={false}
            direction={appDirection}
            isAppSpaceHeaderVisible={isAppSpaceHeaderVisible}
          />
        </CcfBox>
        <CcfBox className={styles.tabsContainerBlock}>
          <CcfTabs
            currentTab={currentTab}
            variant={CcfTabs.Variant.FULL_WIDTH}
            setCurrentTab={handleChange}
            classes={{
              root: styles.tabsContainer,
              indicator: styles.activeTabIndicator,
            }}
          >
            {renderTabPanels()}
          </CcfTabs>
          {initialPopOverMenuContent()}
        </CcfBox>
      </section>
      {renderTabContent()}
    </section>
  );
}

export default CcfAppSpace;
